<template>
  <div>
    <q-model-selector
      v-model="organizationId"
      plugin="organizationalChart"
      delegate="getUserOrganizationList"
      display-field="title"
      value-field="id"
      placeholder="Select Organization ..."
    />
    <q-row
      :gutter="15"
    >
      <component
        :is="getLeftColumn"
        :organization="organization"
      />

      <component
        :is="getRightColumn"
        :organization="organization"
      />
    </q-row>
  </div>
</template>

<script>
  import organizationTree from "./organizationTree";
  import organizationItemDetail from "./organizationItemDetail";

  export default {
    name: "QOrganizationalChart",

    components: {
      'organization-tree': organizationTree,
      'organization-item-detail': organizationItemDetail
    },

    data() {
      return {
        organizationList: [],
        canSubmit: true,
        organizationId: undefined,
        organization: undefined
      }
    },

    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },
      getRightColumn() {
        return this.isRtl ? 'organization-item-detail' : 'organization-tree'
      },
      getLeftColumn() {
        return this.isRtl ? 'organization-tree' : 'organization-item-detail'
      }
    },

    watch: {
      organizationId() {
        this.organization = {};
        if (this.organizationId) {
          this.loadOrganization();
        }
      }
    },

    methods: {
      loadOrganization() {
        this.$service("organizationalChart", "organization", "getEditable", {
          modelId: this.organizationId
        }).then((res) => {
          this.organization = res.result.model;
        })
      },
    }
  }
</script>

<style scoped>

</style>